export default {
  COMMON: "common",
  CELEBRITY: "celebrity",
  CELEBRITY_2: "celebrity2",
  PRO: "pro",
  D28: "d28",
  FULL_SIZE: "full_size",

  sdxl_m1: "sdxl_m1",
  sdxl_m2: "sdxl_m2",
  sdxl_m3: "sdxl_m3",
  sdxl_m4: "sdxl_m4",
  sdxl_m5: "sdxl_m5",
  sdxl_m6: "sdxl_m6",
  sdxl_m7: "sdxl_m7",
  sdxl_m8: "sdxl_m8",

  sdxl_f1: "sdxl_f1",
  sdxl_f2: "sdxl_f2",
  sdxl_f3: "sdxl_f3",
  sdxl_f4: "sdxl_f4",
  sdxl_f5: "sdxl_f5",
  sdxl_f6: "sdxl_f6",
  sdxl_f7: "sdxl_f7",

  d31_m1: "d31_m1",
  d31_m2: "d31_m2",
  d31_m3: "d31_m3",
  d31_m4: "d31_m4",
  d31_m5: "d31_m5",
  d31_m6: "d31_m6",
  d31_f1: "d31_f1",
  d31_f2: "d31_f2",
  d31_f3: "d31_f3",
  d31_f4: "d31_f4",
  d31_f5: "d31_f5",
  d31_f6: "d31_f6",

  users_f1: "users_f1",
  users_f2: "users_f2",
  users_f3: "users_f3",
  users_f4: "users_f4",
  users_f5: "users_f5",
  users_f6: "users_f6",
  users_f7: "users_f7",
  users_m1: "users_m1",
  users_m2: "users_m2",
  users_m3: "users_m3",
  users_m4: "users_m4",
  users_m5: "users_m5",
  users_m6: "users_m6",

  D53_m1: "d53_m1",
  D53_m2: "d53_m2",
  D53_m3: "d53_m3",
  D53_f1: "d53_f1",
  D53_f2: "d53_f2",
};
